import { ArrowRight } from "lucide-react";
import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import homecontactform from "../../Images/homecontactform.webp";
import logo from "../../Images/logo.png";

const ContactForm = () => {
  const [buttonLabel, setButtonLabel] = useState("Get in Touch With Us");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      email: Yup.string().email("Invalid email").required("Email is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setIsSubmitting(true);
      setButtonLabel("Sending...");
      try {
        await axios.post(
          "https://backend.semarsholding.com/simple-contact-form",
          values
        );
        resetForm();
        setButtonLabel("Message Sent!");
        setTimeout(() => setButtonLabel("Get in Touch With Us"), 2500);
      } catch (error) {
        console.error("Submission error:", error);
        setButtonLabel("Failed. Try Again");
        setTimeout(() => setButtonLabel("Get in Touch With Us"), 3000);
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  return (
    <section
      className="h-auto md:h-[80vh] w-full flex flex-col md:flex-row"
      data-aos="fade-up"
    >
      {/* Left Side - Image */}
      <div className="w-full md:w-5/6 h-64 md:h-auto relative">
        <img
          src={homecontactform}
          alt="Modern architecture"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Right Side - Contact Form */}
      <div className="w-full md:w-1/2 bg-[#333333] p-8 md:p-12 lg:p-16 flex flex-col justify-center">
        {/* Logo */}
        <div className="mb-8 flex">
          <div className="pl-0 md:pl-16">
            <img className="w-40 h-16" src={logo} alt="logo" />
          </div>
        </div>

        {/* Description Text */}
        <div className="mb-8 text-gray-300 max-w-md mx-auto text-start">
          <p>Let us know how we can help. We'll be in touch shortly.</p>
        </div>

        {/* Form */}
        <form
          onSubmit={formik.handleSubmit}
          className="space-y-6 max-w-md mx-auto w-full"
        >
          <div>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              className="w-full px-4 py-3 bg-[#2D2D2D] border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-[#C99C48]"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.name}
            />
            {formik.touched.name && formik.errors.name && (
              <p className="text-red-400 text-sm mt-1">{formik.errors.name}</p>
            )}
          </div>
          <div>
            <input
              type="email"
              name="email"
              placeholder="yourmailaddressplease@mail.com"
              className="w-full px-4 py-3 bg-[#2D2D2D] border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-[#C99C48]"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
            />
            {formik.touched.email && formik.errors.email && (
              <p className="text-red-400 text-sm mt-1">{formik.errors.email}</p>
            )}
          </div>
          <div className="pt-2">
            <button
              type="submit"
              disabled={isSubmitting}
              className={`bg-[#C99C48] hover:bg-[#B8914A] text-white font-medium py-3 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 active:scale-95 flex items-center space-x-2 ${
                isSubmitting ? "opacity-70 scale-95 cursor-not-allowed" : ""
              }`}
            >
              <span>{buttonLabel}</span>
              <ArrowRight
                className={`h-5 w-5 transition-transform duration-300 ${
                  isSubmitting ? "translate-x-1" : ""
                }`}
              />
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default ContactForm;
